import {
  useEffect, useCallback, useState, useRef, useMemo,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useHistory } from 'react-router';

import modbusMapsActions from '@state/modbusMaps/actions';
import devicesApi from '@api/devicesApi';
import { message } from 'antd';
import getColumns from './columnsDeviceTypes';

function useDeviceTypes() {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const clientTarget = useSelector(({ user }) => user.clientTarget);
  const abortController = useRef(null);
  const unmountcomponent = useRef(true);
  // const timeoutRef = useRef();
  const timerLopping = useRef();
  const initPagination = useRef({ current: 1, pageSize: 20 });
  const history = useHistory();
  const search = '';
  const [valueFilter, setValueFilter] = useState('');
  // const [search, setSearch] = useState('');

  const [isCreate, setIsCreate] = useState(false);

  const currentUser = useSelector(({ user }) => user);

  const [loading, setLoading] = useState(false);
  const [devicesType, setDevicesType] = useState([]);

  const [pag, setPagination] = useState(initPagination.current);

  const abortLastRequest = useCallback(() => {

    if (abortController.current) {

      abortController.current.abort();
      abortController.current = null;

    }

  }, []);

  const handleTableChange = useCallback( // load device data
    (pagination, filter, sorter) => {

      // const { current, pageSize: limit } = pagination;
      // const offset = (current - 1) * limit;

      abortController.current = new AbortController();
      const { signal } = abortController.current;

      setLoading(true);
      if (timerLopping.current) clearTimeout(timerLopping.current);

      devicesApi.getAllDeviceTypeUnified({ signal })
        .then(async (response) => {

          if (unmountcomponent) {

            const resp = {
              count: response.lenght,
              results: response,
            };
              // eslint-disable-next-line no-shadow
            const { results: devicesType, count: total } = resp;
            setPagination({ ...pagination, total });

            const newDevicesType = await Promise.all(devicesType.map(async (obj) => {

              let modbus_map_name = '';
              let variable_name = '';
              let devices_name = '';

              if (obj?.modbus_map !== null) {

                const arrModbusMap = [];
                Object.entries(obj?.modbus_map).forEach(([key, value]) => {

                  arrModbusMap.push(key);

                });
                // modbus_map_name = arrModbusMap.join(', ');
                modbus_map_name = arrModbusMap?.length || '';

              }

              if (obj?.fields !== null) {

                const dataVariable = await obj?.fields.map((item) => item.edge_name) || [];
                variable_name = dataVariable.join(', ');
                variable_name = dataVariable?.length || '';

              }

              // Obtenemos la cantidad de dispositivo
              devices_name = obj?.devicesList?.length;

              const item = {
                ...obj,
                modbus_map_name,
                fields: obj?.fields || [],
                variable_name,
                devices: obj?.devicesList,
                devices_name,
              };
              return item;

            }));

            setLoading(false);
            setDevicesType(newDevicesType);

            timerLopping.current = setTimeout(
              () => handleTableChange({ pagination, filter, sorter }),
              120000,
            );

          }

        })
        .catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          // eslint-disable-next-line no-console
          console.log(t(fem));
          setLoading(false);

        });

    },
    [clientTarget, search, t],
  );

  const createDeviceType = useCallback( // Go to create /crear-tipo-dispositivo
    () => {

      const defaultData = {
        device_type_name: '',
        device_type_description: '',
        business_type_id: '',
        business_type_name: '',
        maps: [],
        variables: [],
      };
      dispatch(modbusMapsActions.setDeviceTypeIdEdit(null));
      dispatch(modbusMapsActions.setCreateEditValues(defaultData));
      history.push('/dispositivos/tipo-dispositivo/crear-tipo-dispositivo');

    },
    [history],
  );

  const deleteDeviceType = useCallback((e) => { // Delete device by Id

    abortController.current = new AbortController();
    const { signal } = abortController.current;
    const { id } = e;

    devicesApi.deleteDeviceTypeUnified({ signal, id })
      .then((response) => {

        handleTableChange(initPagination.current);
        message.success(t('common.successfully_remove'));

      })
      .catch((error) => {

        message.error(error?.data?.detail || t('common.failed_remove'));

      });

  // eslint-disable-next-line
  }, []);

  const editDeviceType = useCallback((e) => { // edit device, save data device in redux

    const modbus_map = [];
    let arr_variable = [];

    // Organizo mapa modbus
    if (e?.modbus_map !== null) {

      Object.entries(e?.modbus_map).forEach(([key, value]) => {

        if (key !== '') {

          modbus_map.push({
            modbus_name: value.name,
            modbus_function: `${value.function}`,
            modbus_direction: value.addres,
            factor_to_multiply: value.factor,
            modbus_size: value.size,
            datatypes: value.data_type,
          });

        }

      });

    }

    arr_variable = e?.fields?.map((item) => {

      let var_modbus_map = '';
      if (item?.modbus_map?.fields) {

        var_modbus_map = item?.modbus_map?.fields[0];

      }

      return {
        id: item.id,
        id_device_type: item?.device_type || '',
        variable_name: item?.name || '',
        variable_key: item?.edge_name || '',
        variable_modbus_map: var_modbus_map,
        variable_descriptor: item?.descriptor || '',
      };

    });

    let variableMap = [];
    if (arr_variable?.length > 0) {

      const newMapsVariables = arr_variable.map((obj, index) => {

        let itemData;

        const maps = modbus_map?.filter((item) => item.modbus_name === obj.variable_modbus_map);
        if (maps.length > 0) {

          itemData = {
            key: index,
            index,
            ...obj,
            ...maps[0],
          };

        } else {

          itemData = {
            key: index,
            index,
            ...obj,
          };

        }

        return itemData;

      });

      variableMap = newMapsVariables;

    } else {

      variableMap = [];

    }

    const createEditValues = {
      device_type_id: e.id,
      device_type_name: e?.name || '',
      device_type_description: e?.description || '',
      business_type_id: e?.business_type_id || '',
      business_type_name: e?.business_type_name || '',
      maps: modbus_map,
      variables: arr_variable,
      variableMap,
    };

    dispatch(modbusMapsActions.setDeviceTypeIdEdit(e.id));
    dispatch(modbusMapsActions.setCreateEditValues(createEditValues));
    history.push('/dispositivos/tipo-dispositivo/editar-tipo-dispositivo');

  }, [dispatch, history]);

  const detailDeviceType = useCallback((e) => { // edit device, save data device in redux

    const modbus_map = [];
    let arr_variable = [];

    // Organizo mapa modbus
    if (e?.modbus_map !== null) {

      Object.entries(e?.modbus_map).forEach(([key, value]) => {

        if (key !== '') {

          modbus_map.push({
            modbus_name: value.name,
            modbus_function: `${value.function}`,
            modbus_direction: value.addres,
            factor_to_multiply: value.factor,
            modbus_size: value.size,
            datatypes: value.data_type,
          });

        }

      });

    }

    arr_variable = e?.fields?.map((item) => {

      let var_modbus_map = '';
      if (item?.modbus_map?.fields) {

        var_modbus_map = item?.modbus_map?.fields[0];

      }

      return {
        id: item.id,
        id_device_type: item?.device_type || '',
        variable_name: item?.name || '',
        variable_key: item?.edge_name || '',
        variable_modbus_map: var_modbus_map,
        variable_descriptor: item?.descriptor || '',
      };

    });

    const createEditValues = {
      device_type_id: e.id,
      device_type_name: e?.name || '',
      device_type_description: e?.description || '',
      business_type_id: e?.business_type_id || '',
      business_type_name: e?.business_type_name || '',
      maps: modbus_map,
      variables: arr_variable,
    };

    dispatch(modbusMapsActions.setDeviceTypeIdEdit(e.id));
    dispatch(modbusMapsActions.setCreateEditValues(createEditValues));
    history.push('/dispositivos/tipo-dispositivo/ver-tipo-dispositivo');

  }, [dispatch, history]);

  const columns = useMemo(
    () => getColumns(t, deleteDeviceType, editDeviceType, detailDeviceType, currentUser),
    [t, deleteDeviceType, editDeviceType, detailDeviceType, currentUser],
  );

  const arrayFilter = devicesType.filter((data) => ( // Filter by Name
    data.name.toUpperCase().includes(valueFilter.toUpperCase())
  ));

  const getPermissonCreate = useCallback(() => {

    const currentUserRole = currentUser.role;
    // eslint-disable-next-line
    setIsCreate(!!(currentUserRole === 'Superadmin' || currentUserRole === 'Admin'));

  }, []);

  useEffect( // mount component
    () => {

      getPermissonCreate();

      handleTableChange(initPagination.current);
      return abortLastRequest;

    },
    // eslint-disable-next-line
    []
  );

  useEffect(() => () => {

    unmountcomponent.current = false;
    clearTimeout(timerLopping.current);

  });

  return {
    setValueFilter,
    handleTableChange,
    loading,
    arrayFilter,
    devicesType,
    columns,
    pagination: pag,
    createDeviceType,
    isCreate,
  };

}

export default useDeviceTypes;
